import { render, staticRenderFns } from "./AndesclubSummary.vue?vue&type=template&id=65d0e06e&"
import script from "./AndesclubSummary.vue?vue&type=script&lang=js&"
export * from "./AndesclubSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports